import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { default as LoadEspot } from '../../../common/Espot/Espot';
import { isCookiesEnable } from '../../help-center/marketingSupport';

const Espot = props => {
  const { widgetProps, getEspotContent } = props;
  const espotContent = getEspotContent(widgetProps.emsName);

  useEffect(() => {
    isCookiesEnable();

    window.addEventListener('OneTrustGroupsUpdated', () => {
      isCookiesEnable();
    });
  }, [espotContent]);
  return !!espotContent ? <LoadEspot html={espotContent} /> : null;
};

Espot.propTypes = {
  widgetProps: PropTypes.shape({
    emsName: PropTypes.string
  }),
  getEspotContent: PropTypes.func
};

export default Espot;
